// extracted by mini-css-extract-plugin
export default {"container":"section-block_container__2veJ4","shape":"section-block_shape__1LuHY","video":"section-block_video__3avsS","vertical":"section-block_vertical__3Avct"};